<template>
  <div id="bottomRight">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-area" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">按日期统计图</span>
          <div class="decoration2">
            <dv-decoration-2 :reverse="true" style="width:5px;height:6rem;" />
          </div>
        </div>
      </div>
      <!-- 4个主要的数据 -->
      <div class="up">
        <div class="bg-color-black item" v-for="item in titleItem" :key="item.title">
          <p class="ml-3 colorBlue fw-b fs-xl">{{ item.title }}</p>
          <div>
            <dv-digital-flop class="dv-dig-flop ml-1 mt-2 pl-3" :config="item.number" />
          </div>
        </div>
      </div>
      <div>
        <BottomRightChart :sum="sum" />
      </div>
    </div>
  </div>
</template>

<script>
import BottomRightChart from '@/components/echart/bottom/bottomRightChart'
export default {
  components: {
    BottomRightChart
  },
  data() {
    return {
      sum: 0,
      titleItem: [
        {
          number: {
            number: [203],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          title: '今日风险事件数'
        },
        {
          number: {
            number: [50],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          title: '已处置数'
        },
        {
          number: {
            number: [6],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          title: '正在处置数'
        },
        {
          number: {
            number: [12],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 24
            }
          },
          title: '待处置数'
        }
      ]
    }
  },
  mounted() {
    this.changeTiming()
  },
  methods: {
    changeTiming() {
      this.changeNumber()
      setInterval(() => {
        if (this.sum < 800) {
          this.changeNumber()
        }
      }, 6000)
    },
    changeNumber() {
      let sum = 0
      for (let i = 1; i < 4; i++) {
        let item = this.titleItem[i]
        item.number.number[0] += Math.round(Math.random() * 2)
        sum += item.number.number[0]
        item.number = { ...item.number }
      }

      this.titleItem[0].number.number[0] = sum
      this.titleItem[0].number = { ...this.titleItem[0].number }
      this.sum = sum // 总量
    }
  }
}
</script>

<style lang="scss" class>
$box-height: 520px;
$box-width: 100%;
#bottomRight {
  padding: 14px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  //下滑线动态
  .decoration2 {
    position: absolute;
    right: 0.125rem;
  }
  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;
    .active-ring-name {
      padding-top: 10px;
    }
  }
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 24%;
      height: 70px;
      .dv-dig-flop {
        width: 150px;
        height: 30px;
      }
    }
  }
}
</style>
